import { ROLES } from 'utilities/constants';
/**
 * return a full errors inside a JOI validation error object
 */
function checkForErrors(joiErrorObject = []) {
  const errorObjects = {};

  joiErrorObject.forEach((err) => {
    const { context = {}, message } = err ?? {};
    errorObjects[`${context.key}`] = {
      errorMessage: message,
      errorObject: err,
    };
  });

  return errorObjects;
}

function defaultStatusValue({ role }) {
  switch (role) {
    case ROLES.ADMIN:
      return 'active';
    default:
      return '';
  }
}

function removeHtmlTags(str) {
  return str.replace(/<[^>]*>/g, '');
}

export { checkForErrors, defaultStatusValue, removeHtmlTags };
